import {
  CUSTOMER_DISPLAY_BUTTON_POSITION_KEY,
  ROUTES,
  history,
} from 'Utils/constants'
import { useDispatch } from 'react-redux'
import analytics from 'shared/Analytics'

export const useLogout = () => {
  const dispatch = useDispatch()

  const logout = async () => {
    try {
      localStorage.removeItem(CUSTOMER_DISPLAY_BUTTON_POSITION_KEY)
    } catch {
      // The logout flow should continue even if browser storage is unavailable.
    }

    dispatch({ type: 'LOGOUT_USER' })
    dispatch({ type: 'COTIZACION_REMOVE' })
    await analytics.pause()
    history.push(ROUTES.login)
  }

  return { logout }
}
